/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontProductGrid_user$ref = any;
export type StorefrontFeaturedSection_user$ref = any;
export type StorefrontFeaturedSection_user = {
    readonly " $fragmentRefs": StorefrontProductGrid_user$ref;
    readonly " $refType": StorefrontFeaturedSection_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontFeaturedSection_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "StorefrontProductGrid_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'cc33e765bcfb2cbd86cb6ba9c7c0cfd9';
export default node;
